import { Injectable } from '@angular/core';
import { NetworkService } from '../infrastructure/network.service';
import { ConfigService } from '../infrastructure/config.service';

@Injectable()
export class DeliveryInstructionService {
  constructor(public configService: ConfigService, public networkService: NetworkService) { }
  editDeliveryAccountNo: any;
  // Get Delivery Instructions List
  public getDeliveryInstructionList(dashboardFilter) {
    return this.networkService.postRequest(this.configService.getDeliveryInstructionList(), dashboardFilter);
  }

  // Get Delivery Instructions List
  public getDeliveryInstructionAccountList() {
    return this.networkService.getRequest(this.configService.getDeliveryInstructionAccountsList());
  }
  // saveDeliveryInstruction
  public saveDeliveryInstruction(payload) {
    return this.networkService.postRequest(this.configService.saveDeliveryInstructionList(), payload);
  }
  // get edit data
  public getDeliveryInstructionEditData(payload) {
    return this.networkService.getRequest(this.configService.getDeliveryInstructionEditData() + '?accountNumber=' + payload.toString());
  }

  public deleteDeliveryInstruction(payload) {
    return this.networkService.postRequest(this.configService.deleteDeliveryInstruction(), payload);
  }
}
